import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'

// メンバー登録
import MemberRegistration from '@/components/public/MemberRegistration.vue'
import MemberRegistrated from '@/components/public/MemberRegistrated.vue'
import PasswordReset from '@/components/public/PasswordReset.vue'
import PasswordResetComplete from '@/components/public/PasswordResetComplete.vue'

import SignIn from '@/components/public/SignIn.vue'
import Forgot from '@/components/public/Forgot.vue'
import Comp_Forgot from '@/components/public/Comp_Forgot.vue'

import Main from '@/components/Main.vue'

import DashBoard from '@/components/dashboard/DashBoard.vue'

import AnalysisDevice from '@/components/analysis/device/Device.vue'
import AnalysisDeviceDetail from '@/components/analysis/device/Detail.vue'
import AnalysisEvent from '@/components/analysis/event/Event.vue'
import AnalysisEventDetail from '@/components/analysis/event/Detail.vue'
import AnalysisUser from '@/components/analysis/user/User.vue'
import AnalysisUserDetail from '@/components/analysis/user/Detail.vue'

// デバイス
import CuonaDevices from '@/components/cuona/device/Devices.vue'
import CuonaDevice from '@/components/cuona/device/Device.vue'

// グループ
import CuonaGroups from '@/components/cuona/group/Groups.vue'
import CuonaGroup from '@/components/cuona/group/Group.vue'

// イベント
import CuonaEvents from '@/components/cuona/event/Events.vue'
import CuonaEvent from '@/components/cuona/event/Event.vue'

// 右メニュー
import Owners from '@/components/owners/Owners.vue'
import Owner from '@/components/owners/Owner.vue'
import Members from '@/components/members/Members.vue'
import Member from '@/components/members/Member.vue'
import Contract from '@/components/contract/Contract.vue'
import Setting from '@/components/settings/Setting.vue'

// フッターメニュー
import Terms from '@/components/public/Terms.vue'
import Privacy from '@/components/public/Privacy.vue'

// エラーページ
import E404 from '@/components/error/404.vue'
import E500 from '@/components/error/500.vue'
import E503 from '@/components/error/503.vue'

const Wrapper = {
  template: "<router-view />"
}

Vue.use(Router)

var router =  new Router({
  mode: 'history',
  routes: [
    {
      path: "/sign_in",
      name: "sign_in",
      component: SignIn,
    },
    {
      path: "/forgot",
      name: "forgot",
      component: Forgot,
    },
    {
      path: "/forgot/complate",
      name: "comp_forgot",
      component: Comp_Forgot,
    },
    {
      path: '*',
      component: E404
    },
    {
      path: '/500',
      meta: { requiresServerErrorAuth: true },
      component: E500
    },
    {
      path: '/503',
      meta: { requiresServerErrorAuth: true },
      component: E503
    },
    {
      path: "/registration/:token",
      component: Wrapper,
      children: [
        {
          path: '',
          component: MemberRegistration
        },
        {
          path: 'done',
          name: 'registration_done',
          meta: { requiresManagerAuth: true },
          component: MemberRegistrated
        }
      ]
    },
    {
      path: "/password_reset/:token",
      component: Wrapper,
      children: [
        {
          path: '',
          component: PasswordReset
        },
        {
          path: 'done',
          name: 'password_reset_done',
          meta: { requiresManagerAuth: true },
          component: PasswordResetComplete
        }
      ]
    },
    {
      path: "/",
      component: Main,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          component: DashBoard,
          meta: [
            { name: 'menus.dashboard' }
          ]
        },
        {
          path: "dashboard",
          component: DashBoard,
          meta: [
            { name: 'menus.dashboard' }
          ]
        },
        {
          path: "analysis/user",
          component: Wrapper,
          children: [
            {
              path: '',
              component: AnalysisUser,
              meta: [
                { name: 'menus.analytics' },
                { name: 'menus.user' }
              ]
            },
            {
              path: ':id',
              component: AnalysisUserDetail,
              name: 'analysisUserDetail',
              meta: [
                { name: 'menus.analytics' },
                { name: 'menus.user', path: '/analysis/user' },
                { name: '' }
              ]
            }
          ]
        },
        {
          path: "analysis/event",
          component: Wrapper,
          children: [
            {
              path: '',
              component: AnalysisEvent,
              meta: [
                { name: 'menus.analytics' },
                { name: 'menus.event' }
              ]
            },
            {
              path: ':id',
              component: AnalysisEventDetail,
              name: 'analysisEventDetail',
              meta: [
                { name: 'menus.analytics' },
                { name: 'menus.event', path: '/analysis/event' },
                { name: '' }
              ]
            }
          ]
        },
        {
          path: "analysis/device",
          component: Wrapper,
          children: [
            {
              path: '',
              component: AnalysisDevice,
              meta: [
                { name: 'menus.analytics'  },
                { name: 'menus.device' }
              ]
            },
            {
              path: ':nfc_uid',
              component: AnalysisDeviceDetail,
              name: 'analysisDeviceDetail',
              meta: [
                { name: 'menus.analytics' },
                { name: 'menus.device', path: '/analysis/device' },
                { name: '' }
              ]
            }
          ]
        },
        {
          path: 'cuona/device/',
          component: Wrapper,
          children: [
            {
              path: '',
              component: CuonaDevices,
              meta: [
                { name: 'menus.cuona' },
                { name: 'menus.devices' }
              ]
            },
            {
              path: ':id',
              name: 'device',
              component: CuonaDevice,
              meta: [
                { name: 'menus.cuona' },
                { name: 'menus.devices', path: '/cuona/device' },
                { name: '' }
              ]
            }
          ]
        },
        {
          path: 'cuona/group/',
          component: Wrapper,
          children: [
            {
              path: '',
              component: CuonaGroups,
              meta: [
                { name: 'menus.cuona' },
                { name: 'menus.group' }
              ]
            },
            {
              path: ':id',
              name: 'group',
              component: CuonaGroup,
              meta: [
                { name: 'menus.cuona' },
                { name: 'menus.group', path: '/cuona/group' },
                { name: '' }
              ]
            }
          ]
        },
        {
          path: 'cuona/event/',
          component: Wrapper,
          children: [
            {
              path: '',
              component: CuonaEvents,
              meta: [
                { name: 'menus.cuona' },
                { name: 'menus.event' }
              ]
            },
            {
              path: ':id',
              name: 'event',
              component: CuonaEvent,
              meta: [
                { name: 'menus.cuona' },
                { name: 'menus.event', path: '/cuona/event' },
                { name: '' }
              ]
            }
          ]
        },
        {
          path: 'owners/',
          component: Wrapper,
          children: [
            {
              path: '',
              component: Owners,
              meta: [
                { name: 'submenus.owners' }
              ]
            },
            {
              path: ':id',
              name: 'owner',
              component: Owner,
              meta: [
                { name: 'submenus.owners', path: '/owners/' },
                { name: '' }
              ]
            }
          ]
        },
        {
          path: 'member/',
          component: Wrapper,
          children: [
            {
              path: '',
              component: Members,
              meta: [
                {
                  name: 'submenus.member',
                }
              ]
            },
            {
              path: ':id',
              name: 'member',
              component: Member,
              meta: [
                {
                  name: 'submenus.member',
                  path: '/member'
                },
                {
                  name: '',
                }
              ]
            },
          ]
        },
        {
          path: 'contract',
          component: Contract,
          meta: [
            {
              name: 'submenus.contract',
            }
          ]
        },
        {
          path: 'setting',
          component: Setting,
          meta: [
            {
              name: 'submenus.setting',
            }
          ]
        }
      ]
    },
    {
      path: "/terms",
      name: 'footer_menus.terms',
      component: Terms
    },
    {
      path: "/privacy",
      name: 'footer_menus.privacy',
      component: Privacy
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    const mainView = document.getElementById("main-view");
    if(mainView !== null) {
      mainView.scrollTop = 0;
    }
    return { x: 0, y: 0 };
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !store.state.auth.signedIn ) {
    next({ path: '/sign_in'});
  } else {
    next();
  }

  // 管理者登録完了ページにurl指定で直接入れないように
  if (to.matched.some(record => record.meta.requiresManagerAuth) && !(from.path.indexOf('/registration') != -1) ) {
    next({ path: '/sign_in'});
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  if (Array.isArray(to.meta) && to.meta[0].name) {
    store.dispatch('setBreadcrumbs', to.meta)
  }
})

export default router
